import { render, staticRenderFns } from "./forcedMatching.vue?vue&type=template&id=287dd530&scoped=true"
import script from "./forcedMatching.vue?vue&type=script&lang=js"
export * from "./forcedMatching.vue?vue&type=script&lang=js"
import style0 from "./forcedMatching.vue?vue&type=style&index=0&id=287dd530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287dd530",
  null
  
)

export default component.exports